import { useState, useEffect } from 'react';

function useDetectSize() {
  const isClient = typeof window === 'object';

  function getSize() {
    if (isClient && window.innerWidth <= 767) {
      return 1;
    }
    if (isClient && window.innerWidth <= 1023) {
      return null; //DIRTY HACK
    }
    return 0;
  }

  const [isMobile, setIsMobile] = useState(getSize);

  useEffect(() => {
    if (!isClient) {
      return 0;
    }

    function handleResize() {
      setIsMobile(getSize());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
}

export default useDetectSize;
